import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getAllUser(): Observable<any> {
    return this.http.get(`${environment.api_URL}/users`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  createUser(userData: any): Observable<any> {
    return this.http
      .post(`${environment.api_URL}/users/adduser`, userData)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          // Handle SSR
          if (!isPlatformBrowser(this.platformId)) {
            return of({ status: false, message: 'SSR mode' });
          }
          let apiMessage = 'An unexpected error occurred';
          if (error.error) {
            if (error.error.error?.message) {
              apiMessage = error.error.error.message;
            } else if (error.error.message) {
              apiMessage = error.error.message;
            } else if (typeof error.error === 'string') {
              apiMessage = error.error;
            }
          } else {
            apiMessage = error.message || 'Server error';
          }
          return throwError(() => ({
            status: false,
            message: apiMessage,
            originalError: error,
          }));
        })
      );
  }

  getUserDetails(id: string): Observable<any> {
    return this.http.get(`${environment.api_URL}/users/${id}`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  getUserSharedPropertyLink(id: string): Observable<any> {
    return this.http.get(`${environment.api_URL}/users/${id}/sh-pro`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  getUserPropertyReq(id: string): Observable<any> {
    return this.http.get(`${environment.api_URL}/property/user/${id}`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }
  getAllMircoMarketReq(): Observable<any> {
    return this.http.get(`${environment.api_URL}/clusters`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }
  assignedAdvisor(data:any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/auth/assign-advisor`,data).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }
  getUserUpdateState(id: string,state:string, reason:string): Observable<any> {
    return this.http.patch(`${environment.api_URL}/users/${id}/approval`,{state:`${state}`,statusReason:`${reason}`}).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }
  deleteUser(id: string): Observable<any> {
    return this.http.delete(`${environment.api_URL}/users/${id}`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }


  // user costomer preference 
  getAllUserPreference(): Observable<any> {
    return this.http.get(`${environment.api_URL}/cust-pref`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  editUser(userId: string, payload: any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/auth/edit/${userId}`,payload).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  createUserPreference(reqData: any): Observable<any> {
    return this.http
      .post(`${environment.api_URL}/cust-pref`, reqData)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          // Handle SSR
          if (!isPlatformBrowser(this.platformId)) {
            return of({ status: false, message: 'SSR mode' });
          }
          let apiMessage = 'An unexpected error occurred';
          if (error.error) {
            if (error.error.error?.message) {
              apiMessage = error.error.error.message;
            } else if (error.error.message) {
              apiMessage = error.error.message;
            } else if (typeof error.error === 'string') {
              apiMessage = error.error;
            }
          } else {
            apiMessage = error.message || 'Server error';
          }
          return throwError(() => ({
            status: false,
            message: apiMessage,
            originalError: error,
          }));
        })
      );
  }
  getUserPropertyPreferenceReq(id: string): Observable<any> {
    return this.http.get(`${environment.api_URL}/cust-pref/${id}`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }

  parsePriceRange(rangeStr: string) {
    const cleanStr = rangeStr.replace(/[₹\s]/g, '').toLowerCase();
    const convertToNumber = (val: string): number => {
      const num = parseFloat(val);
      if (val.includes('cr')) return num * 10000000;
      if (val.includes('l')) return num * 100000;
      return num;
    };
  
    // "25Cr+"
    if (cleanStr.includes('+')) {
      const value = cleanStr.replace('+', '');
      return {
        min: convertToNumber(value),
        max: Infinity
      };
    }
  
    //range "10Cr-20Cr"
    const parts = cleanStr.split(/[–-]/);
  
    return {
      min: convertToNumber(parts[0]),
      max: convertToNumber(parts[1])
    };
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      return `Network error: ${error.error.message}`;
    } 
    
    // Backend returned an unsuccessful response code
    // NestJS usually sends: { message: "...", error: "...", statusCode: 400 }
    if (error.error && error.error.message) {
      return Array.isArray(error.error.message) 
        ? error.error.message[0]  // Handle class-validator arrays
        : error.error.message;
    }
  
    return `Server Error: ${error.statusText || 'Internal Server Error'}`;
  }

  getStatusClass(state: string | undefined): string {
    let stateUser = state ?? 'Pending'
    const styles:any = {
      'Pending': 'bg-yellow-100 text-yellow-800 border-yellow-200',
      'Approved': 'bg-green-100 text-green-800 border-green-200',
      'Rejected': 'bg-red-100 text-red-800 border-red-200'
    };
    // Fallback to gray if state doesn't match
    return styles[stateUser] ?? 'bg-gray-100 text-gray-700 border-gray-200';
  }
}
